// Port geocoding utility - maps port names to coordinates
// This is a lookup table for common cruise ports
// In production, you might want to use a geocoding API for unknown ports

const portCoordinates = {
  // US Ports
  'Miami, FL': [25.7617, -80.1918],
  'Miami': [25.7617, -80.1918],
  'Port Canaveral, FL': [28.4106, -80.6181],
  'Port Canaveral': [28.4106, -80.6181],
  'Fort Lauderdale, FL': [26.1224, -80.1373],
  'Fort Lauderdale': [26.1224, -80.1373],
  'Tampa, FL': [27.9506, -82.4572],
  'Tampa': [27.9506, -82.4572],
  'Jacksonville, FL': [30.3322, -81.6557],
  'Jacksonville': [30.3322, -81.6557],
  'Charleston, SC': [32.7765, -79.9311],
  'Charleston': [32.7765, -79.9311],
  'Norfolk, VA': [36.8468, -76.2852],
  'Norfolk': [36.8468, -76.2852],
  'Baltimore, MD': [39.2904, -76.6122],
  'Baltimore': [39.2904, -76.6122],
  'New York, NY': [40.7128, -74.0060],
  'New York': [40.7128, -74.0060],
  'Boston, MA': [42.3601, -71.0589],
  'Boston': [42.3601, -71.0589],
  'Seattle, WA': [47.6062, -122.3321],
  'Seattle': [47.6062, -122.3321],
  'San Francisco, CA': [37.7749, -122.4194],
  'San Francisco': [37.7749, -122.4194],
  'Los Angeles, CA': [34.0522, -118.2437],
  'Los Angeles': [34.0522, -118.2437],
  'San Diego, CA': [32.7157, -117.1611],
  'San Diego': [32.7157, -117.1611],
  'Galveston, TX': [29.3013, -94.7977],
  'Galveston': [29.3013, -94.7977],
  'New Orleans, LA': [29.9511, -90.0715],
  'New Orleans': [29.9511, -90.0715],
  
  // Caribbean Ports
  'Nassau, Bahamas': [25.0479, -77.3554],
  'Nassau': [25.0479, -77.3554],
  'Freeport, Bahamas': [26.5333, -78.7000],
  'Freeport': [26.5333, -78.7000],
  'Cozumel, Mexico': [20.5083, -86.9458],
  'Cozumel': [20.5083, -86.9458],
  'Grand Cayman': [19.3133, -81.2546],
  'George Town, Grand Cayman': [19.3133, -81.2546],
  'Jamaica': [18.1096, -77.2975],
  'Montego Bay, Jamaica': [18.4712, -77.9188],
  'Montego Bay': [18.4712, -77.9188],
  'Ocho Rios, Jamaica': [18.4025, -77.1047],
  'Ocho Rios': [18.4025, -77.1047],
  'Falmouth, Jamaica': [18.4933, -77.6558],
  'Falmouth': [18.4933, -77.6558],
  'St. Thomas, USVI': [18.3358, -64.8961],
  'St. Thomas': [18.3358, -64.8961],
  'St. Maarten': [18.0425, -63.0548],
  'St. Martin': [18.0425, -63.0548],
  'San Juan, Puerto Rico': [18.4655, -66.1057],
  'San Juan': [18.4655, -66.1057],
  'St. Kitts': [17.3578, -62.7830],
  'Basseterre, St. Kitts': [17.3578, -62.7830],
  'Barbados': [13.1939, -59.5432],
  'Bridgetown, Barbados': [13.1939, -59.5432],
  'Aruba': [12.5211, -70.0370],
  'Oranjestad, Aruba': [12.5211, -70.0370],
  'Curacao': [12.1696, -68.9900],
  'Willemstad, Curacao': [12.1696, -68.9900],
  'Bonaire': [12.1784, -68.2385],
  'Kralendijk, Bonaire': [12.1784, -68.2385],
  'St. Lucia': [14.0101, -60.9875],
  'Castries, St. Lucia': [14.0101, -60.9875],
  'Antigua': [17.0608, -61.7964],
  'St. John\'s, Antigua': [17.0608, -61.7964],
  'Dominica': [15.4150, -61.3710],
  'Roseau, Dominica': [15.4150, -61.3710],
  'Grenada': [12.1165, -61.6790],
  'St. George\'s, Grenada': [12.1165, -61.6790],
  'Tortola, BVI': [18.4207, -64.6200],
  'Tortola': [18.4207, -64.6200],
  'Labadee, Haiti': [19.7874, -72.2539],
  'Labadee': [19.7874, -72.2539],
  'CocoCay, Bahamas': [25.7833, -77.9333],
  'CocoCay': [25.7833, -77.9333],
  'Perfect Day at CocoCay': [25.7833, -77.9333],
  
  // Mexican Riviera
  'Cabo San Lucas, Mexico': [22.8905, -109.9167],
  'Cabo San Lucas': [22.8905, -109.9167],
  'Puerto Vallarta, Mexico': [20.6534, -105.2253],
  'Puerto Vallarta': [20.6534, -105.2253],
  'Mazatlan, Mexico': [23.2494, -106.4111],
  'Mazatlan': [23.2494, -106.4111],
  'Ensenada, Mexico': [31.8667, -116.6000],
  'Ensenada': [31.8667, -116.6000],
  
  // Alaska
  'Juneau, AK': [58.3019, -134.4197],
  'Juneau': [58.3019, -134.4197],
  'Ketchikan, AK': [55.3422, -131.6461],
  'Ketchikan': [55.3422, -131.6461],
  'Skagway, AK': [59.4547, -135.3133],
  'Skagway': [59.4547, -135.3133],
  'Sitka, AK': [57.0531, -135.3300],
  'Sitka': [57.0531, -135.3300],
  'Icy Strait Point, AK': [58.3333, -135.5000],
  'Icy Strait Point': [58.3333, -135.5000],
  'Glacier Bay, AK': [58.6667, -136.0000],
  'Glacier Bay': [58.6667, -136.0000],
  'Hubbard Glacier, AK': [59.9167, -141.2500],
  'Hubbard Glacier': [59.9167, -141.2500],
  'Tracy Arm, AK': [57.8333, -133.6667],
  'Tracy Arm': [57.8333, -133.6667],
  
  // Europe
  'Barcelona, Spain': [41.3851, 2.1734],
  'Barcelona': [41.3851, 2.1734],
  'Rome, Italy': [41.9028, 12.4964],
  'Rome': [41.9028, 12.4964],
  'Civitavecchia, Italy': [42.0934, 11.7968],
  'Civitavecchia': [42.0934, 11.7968],
  'Venice, Italy': [45.4408, 12.3155],
  'Venice': [45.4408, 12.3155],
  'Naples, Italy': [40.8518, 14.2681],
  'Naples': [40.8518, 14.2681],
  'Athens, Greece': [37.9838, 23.7275],
  'Athens': [37.9838, 23.7275],
  'Piraeus, Greece': [37.9420, 23.6462],
  'Piraeus': [37.9420, 23.6462],
  'Santorini, Greece': [36.3932, 25.4615],
  'Santorini': [36.3932, 25.4615],
  'Mykonos, Greece': [37.4467, 25.3289],
  'Mykonos': [37.4467, 25.3289],
  'Istanbul, Turkey': [41.0082, 28.9784],
  'Istanbul': [41.0082, 28.9784],
  'Dubrovnik, Croatia': [42.6507, 18.0944],
  'Dubrovnik': [42.6507, 18.0944],
  'Split, Croatia': [43.5081, 16.4402],
  'Split': [43.5081, 16.4402],
  'Kotor, Montenegro': [42.4247, 18.7712],
  'Kotor': [42.4247, 18.7712],
  'Marseille, France': [43.2965, 5.3698],
  'Marseille': [43.2965, 5.3698],
  'Copenhagen, Denmark': [55.6761, 12.5683],
  'Copenhagen': [55.6761, 12.5683],
  'Stockholm, Sweden': [59.3293, 18.0686],
  'Stockholm': [59.3293, 18.0686],
  'Helsinki, Finland': [60.1699, 24.9384],
  'Helsinki': [60.1699, 24.9384],
  'St. Petersburg, Russia': [59.9343, 30.3351],
  'St. Petersburg': [59.9343, 30.3351],
  'Tallinn, Estonia': [59.4370, 24.7536],
  'Tallinn': [59.4370, 24.7536],
  'Reykjavik, Iceland': [64.1466, -21.9426],
  'Reykjavik': [64.1466, -21.9426],
  'Southampton, UK': [50.9097, -1.4044],
  'Southampton': [50.9097, -1.4044],
  'London, UK': [51.5074, -0.1278],
  'London': [51.5074, -0.1278],
  
  // Asia
  'Singapore': [1.3521, 103.8198],
  'Hong Kong': [22.3193, 114.1694],
  'Tokyo, Japan': [35.6762, 139.6503],
  'Tokyo': [35.6762, 139.6503],
  'Yokohama, Japan': [35.4437, 139.6380],
  'Yokohama': [35.4437, 139.6380],
  'Bangkok, Thailand': [13.7563, 100.5018],
  'Bangkok': [13.7563, 100.5018],
  'Dubai, UAE': [25.2048, 55.2708],
  'Dubai': [25.2048, 55.2708],
  
  // Australia/New Zealand
  'Sydney, Australia': [-33.8688, 151.2093],
  'Sydney': [-33.8688, 151.2093],
  'Melbourne, Australia': [-37.8136, 144.9631],
  'Melbourne': [-37.8136, 144.9631],
  'Auckland, New Zealand': [-36.8485, 174.7633],
  'Auckland': [-36.8485, 174.7633],
  
  // South America
  'Rio de Janeiro, Brazil': [-22.9068, -43.1729],
  'Rio de Janeiro': [-22.9068, -43.1729],
  'Buenos Aires, Argentina': [-34.6037, -58.3816],
  'Buenos Aires': [-34.6037, -58.3816],
  'Lima, Peru': [-12.0464, -77.0428],
  'Lima': [-12.0464, -77.0428],
  'Valparaiso, Chile': [-33.0472, -71.6127],
  'Valparaiso': [-33.0472, -71.6127],
};

/**
 * Get coordinates for a port name
 * @param {string} portName - The name of the port
 * @returns {Array|null} - [latitude, longitude] or null if not found
 */
export function getPortCoordinates(portName) {
  if (!portName) return null;
  
  // Try exact match first
  if (portCoordinates[portName]) {
    return portCoordinates[portName];
  }
  
  // Try case-insensitive match
  const normalizedName = portName.trim();
  for (const [key, coords] of Object.entries(portCoordinates)) {
    if (key.toLowerCase() === normalizedName.toLowerCase()) {
      return coords;
    }
  }
  
  // Try partial match (e.g., "Miami" matches "Miami, FL")
  for (const [key, coords] of Object.entries(portCoordinates)) {
    if (key.toLowerCase().includes(normalizedName.toLowerCase()) ||
        normalizedName.toLowerCase().includes(key.toLowerCase())) {
      return coords;
    }
  }
  
  return null;
}

/**
 * Geocode a port name using a fallback method
 * For unknown ports, you could integrate with a geocoding API here
 * @param {string} portName - The name of the port
 * @returns {Promise<Array|null>} - [latitude, longitude] or null
 */
export async function geocodePort(portName) {
  // First try the lookup table
  const coords = getPortCoordinates(portName);
  if (coords) {
    return coords;
  }
  
  // For unknown ports, you could use a geocoding API like:
  // - OpenStreetMap Nominatim (free, no API key needed)
  // - Google Geocoding API
  // - Mapbox Geocoding API
  
  // For now, return null for unknown ports
  console.warn(`Port coordinates not found for: ${portName}`);
  return null;
}

